import $ from 'jquery'

export default () => {
    let tables = document.querySelectorAll('table')
    
    tables.forEach((table) => {
        let wrapper = document.createElement('div')
        wrapper.style.overflow = 'auto'

        table.parentNode.insertBefore(wrapper, table)
        wrapper.append(table)
    });
}
